import React from "react";

type Column = { key: string; label: string };
type Row = Record<string, string>;

type ComparisonTableProps = {
  columns: Column[];
  rows: Row[];
};

export function ComparisonTable({ columns, rows }: ComparisonTableProps) {
  if (!columns || columns.length === 0) return null;

  return (
    <div className="my-8 overflow-x-auto w-full rounded border border-[var(--line)]">
      <table className="w-full border-collapse text-sm text-left">
        <thead>
          <tr className="bg-[var(--foreground)] text-[var(--background)] dark:bg-[var(--surface-muted)] dark:text-[var(--foreground)]">
            {columns.map((col) => (
              <th
                key={col.key}
                className="p-3 sm:p-4 font-mono font-bold text-xs uppercase tracking-widest"
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const isHighlighted = row[columns[0].key]?.includes("*") || false;
            const rowBg = i % 2 === 0 ? "bg-[var(--surface)]" : "bg-[var(--surface-muted)]";

            return (
              <tr
                key={i}
                className={`${rowBg} ${
                  isHighlighted ? "font-bold text-[var(--accent)]" : "text-[var(--ink-soft)]"
                }`}
              >
                {columns.map((col) => {
                  return (
                    <td
                      key={col.key}
                      className="p-3 sm:p-4 border-b border-[var(--line)] font-sans"
                    >
                      {row[col.key]}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
